'use client';
import { Popover } from 'antd';
import cn from 'classnames';
import React, { useEffect } from 'react';

import { ReactComponent as SortIcon } from '@/app/_icons/sort-icon.svg';
import { minDesktop } from '@/constants/vars.constants';
import { useWindowSize } from '@/hooks/window-size.hook';

import styles from './search-result-select.module.scss';

export const SearchResultSelect: React.FC<{
  content: React.ReactElement;
  setIsVisible: (visible: boolean) => void;
  children: React.ReactNode;
  isVisible: boolean;
  contentProps?: boolean;
  overlayClassName?: string;
}> = ({
  content,
  setIsVisible,
  isVisible,
  children,
  contentProps,
  overlayClassName = '',
}) => {
  const size = useWindowSize();
  const handleVisibleChange = (visible: boolean) => {
    if (size?.width < minDesktop && visible) {
      document.body.style.overflow = 'hidden';
    } else if (size?.width < minDesktop && !visible) {
      document.body.style.overflow = 'visible';
    }

    if (!visible) {
      if (size?.width < minDesktop) {
        const filterPopoversClose =
          document.querySelectorAll<HTMLElement>('.mobileFilter');

        filterPopoversClose.forEach((item) => {
          item.style.opacity = '0';
        });
        setTimeout(() => {
          setIsVisible(visible);
        }, 300);
      } else {
        setIsVisible(visible);
      }
    } else {
      setIsVisible(visible);
      if (size?.width < minDesktop) {
        setTimeout(() => {
          const filterPopoversOpen =
            document.querySelectorAll<HTMLElement>('.mobileFilter');

          filterPopoversOpen.forEach((item) => {
            item.style.opacity = '1';
          });
        }, 300);
      }
    }
  };

  useEffect(() => {
    if (!isVisible) {
      handleVisibleChange(isVisible);
    }
  }, [isVisible]);

  const contentWithProps = React.cloneElement(
    content as React.ReactElement<any>,
    { handleVisibleChange },
  );

  return (
    <Popover
      placement={'bottomRight'}
      trigger="click"
      visible={isVisible}
      onVisibleChange={handleVisibleChange}
      content={contentProps ? contentWithProps : content}
      overlayClassName={overlayClassName}
    >
      <div className={styles.selectInput}>
        {children}
        <SortIcon
          className={cn(styles.selectTriangle, {
            [styles.selectTriangleActive as string]: isVisible,
          })}
          height={14}
          width={14}
        />
      </div>
    </Popover>
  );
};
